var ______ = (function (me) {

    me.init = function(){
     	if(!$('body').hasClass('route-______')) return;
   	
    };

    return me;
}(______ || {}));
